import { Page as RulesPage } from "@wg/wows-react-uikit";
import * as React from "react";
import dwhExport from '~/dwhExport';
import settings from "../../../settings";
import { searchToObject } from "../../../utils";
import { clanBattlesRules, clanBrawlsRules } from "../rules";

export type ClanBattlesRulesPage_Props = {};

const BRAWL = 'brawl';
const CVC = 'cvc';

class ClanBattlesRulesPage extends React.PureComponent<ClanBattlesRulesPage_Props, any> {

  componentDidMount() {
    dwhExport.send('clan_battles.view_rules')
  }
  
  isLastSeasonBrawl = () => {
    const searchParams = searchToObject();
    let isBrawl = false;

    if (settings && settings.ladder && settings.ladder.seasons) {
      const lastSeason = settings.ladder.seasons[settings.ladder.lastSeasonId];
      if (lastSeason) {
        if (lastSeason.season_type === BRAWL || lastSeason.kind === BRAWL) {
          isBrawl = true;
        }
      }
    }

    switch (searchParams.force) {
      case CVC:
        {
          isBrawl = false;
          break;
        }
      case BRAWL:
        {
          isBrawl = true;
          break;
        }
      default:
        {
          break;
        }

    }

    return isBrawl;
  };

  render() {
    const isBrawl = this.isLastSeasonBrawl();
    if (isBrawl) {
      return [<RulesPage key={'ClanBrawlsRulesPage'} startAnimationIndex={1} rules={clanBrawlsRules} />, <RulesPage key={'ClanBattlesRulesPage'} startAnimationIndex={clanBrawlsRules.items.length + 1} rules={clanBattlesRules} />];
    } else {
      return [<RulesPage key={'ClanBattlesRulesPage'} startAnimationIndex={1} rules={clanBattlesRules} />, <RulesPage key={'ClanBrawlsRulesPage'} startAnimationIndex={clanBattlesRules.items.length + 1} rules={clanBrawlsRules} />];
    }
  }
}

export default ClanBattlesRulesPage;